import { Component, input } from '@angular/core';
import { ComponentVariant, ComponentSize } from '../types';

@Component({
  selector: 'app-badge',
  imports: [],
  template: `
    <span [class]="badgeClasses" [attr.aria-label]="label()">
      @if (icon()) {
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="icon()" />
        </svg>
      }
      <ng-content></ng-content>
    </span>
  `,
  styles: []
})
export class BadgeComponent {
  variant = input<ComponentVariant>('primary');
  size = input<ComponentSize>('md');
  label = input<string>('');
  icon = input<string>('');
  dot = input<boolean>(false);
  rounded = input<boolean>(true);

  get badgeClasses(): string {
    const classes = ['inline-flex', 'items-center', 'gap-1', 'font-medium', 'whitespace-nowrap'];

    // Size
    const sizeMap = {
      xs: 'text-xs px-1.5 py-0.5',
      sm: 'text-xs px-2 py-1',
      md: 'text-sm px-2.5 py-1',
      lg: 'text-base px-3 py-1.5',
      xl: 'text-lg px-4 py-2'
    };
    classes.push(sizeMap[this.size()]);

    // Rounded
    if (this.rounded()) {
      classes.push('rounded-full');
    } else {
      classes.push('rounded-md');
    }

    // Variant colors
    if (this.dot()) {
      classes.push('w-2', 'h-2', 'p-0', 'rounded-full');
      const dotMap: Record<ComponentVariant, string> = {
        success: 'bg-green-500',
        error: 'bg-red-500',
        warning: 'bg-yellow-500',
        info: 'bg-blue-500',
        primary: 'bg-blue-600',
        secondary: 'bg-gray-500',
        danger: 'bg-red-500'
      };
      classes.push(dotMap[this.variant()] || dotMap.primary);
    } else {
      const variantMap: Record<ComponentVariant, string> = {
        success: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
        error: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
        warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
        info: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
        primary: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
        secondary: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
        danger: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
      };
      classes.push(variantMap[this.variant()] || variantMap.primary);
    }

    return classes.join(' ');
  }
}

